// User-facing categories that map to Zammad groups
export const TICKET_CATEGORIES = {
  HARDWARE: 'Hardware',
  WEB_APP: 'Web App',
  MOBILE_APP: 'Mobile App',
  FEATURE_REQUEST: 'Feature Request',
} as const;

export type TicketCategory = (typeof TICKET_CATEGORIES)[keyof typeof TICKET_CATEGORIES];

// Mapping of user-facing categories to Zammad group IDs
export const CATEGORY_TO_GROUP_ID: Record<TicketCategory, number> = {
  [TICKET_CATEGORIES.HARDWARE]: 2,
  [TICKET_CATEGORIES.WEB_APP]: 4,
  [TICKET_CATEGORIES.MOBILE_APP]: 4,
  [TICKET_CATEGORIES.FEATURE_REQUEST]: 2,
};

// Mapping of group IDs to group names (for API)
export const GROUP_ID_TO_NAME: Record<number, string> = {
  2: 'Support', // Hardware & Feature Request
  4: 'Development', // Web App & Mobile App
};

// Priority is always "2 normal" - we triage internally
export const DEFAULT_PRIORITY_ID = 2;
export const DEFAULT_PRIORITY_NAME = '2 normal';
